const API_BASE = import.meta.env.VITE_API_URL ?? "https://insonuchun.uz/api";
// const API_BASE = import.meta.env.VITE_API_URL ?? "https://skr.ihma.uz/api";

function getBaseUrl(): string {
  try {
    return new URL(API_BASE).origin;
  } catch {
    // return "https://skr.ihma.uz";
    return "https://insonuchun.uz";
  }
}

/**
 * Bola fotosini yuklash: ${baseUrl}/api/File/DownloadFile/${patientPhotoId}
 */
export function getPatientImageUrl(patientPhotoId: string | null | undefined): string {
  if (!patientPhotoId) return "";
  if (patientPhotoId.startsWith("http")) return patientPhotoId;
  const baseUrl = getBaseUrl();
  return `${baseUrl}/api/File/DownloadFile/${patientPhotoId}`;
}

/**
 * Fond ikonkasini yuklash: ${baseUrl}/api/Fond/DownloadFile/${fondIcon}
 */
export function getFondIconUrl(fondIcon: string | null | undefined): string {
  if (!fondIcon) return "";
  if (fondIcon.startsWith("http")) return fondIcon;
  const baseUrl = getBaseUrl();
  return `${baseUrl}/api/Fond/DownloadFile/${fondIcon}`;
}

/**
 * Klinika ikonkasini yuklash: ${baseUrl}/api/Clinic/DownloadFile/${clinicIcon}
 */
export function getClinicIconUrl(clinicIcon: string | null | undefined): string {
  if (!clinicIcon) return "";
  if (clinicIcon.startsWith("http")) return clinicIcon;
  const baseUrl = getBaseUrl();
  return `${baseUrl}/api/Clinic/DownloadFile/${clinicIcon}`;
}
